import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { CustomScrollbar } from './CustomScrollbar';

import styles from './css/DropdownList.module.css';

const CustomMenuList = ({ children }) => {
  const { t } = useTranslation('common');
  const containerRef = useRef(null);
  const listRef = useRef(null);

  const hasOptions = React.Children.count(children) > 0;

  return (
    <div
      ref={containerRef}
      className={styles.dropdownListContainer}
    >
      <div
        ref={listRef}
        className={styles.dropdownList}
      >
        {hasOptions ? (
          children
        ) : (
          <div className={styles.emptyState}>
            {t('resultsNotFound')}
          </div>
        )}
      </div>

      <CustomScrollbar
        containerRef={containerRef}
        listRef={listRef}
      />
    </div>
  );
};

export { CustomMenuList };
